// extracted by mini-css-extract-plugin
module.exports = {"input":"inAWordContent_input__ASQ25","inputContent":"inAWordContent_inputContent__taEY_","word":"inAWordContent_word__EhiZY"};